import * as AuthActions from './auth.actions'

import { Action, createReducer, on } from '@ngrx/store'
import { FrontState } from 'libs/gb-front/core/data-access/src/lib/+state/front-state.models'
import { ProfileEntity } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.models'
import { AuthenticationEntity, AuthErrors } from './auth.models'

export const AUTH_FEATURE_KEY = 'authentication'

export interface AuthenticationState extends AuthenticationEntity {
  errors?: AuthErrors | null // last known errors (if any)
}

export const initialState: AuthenticationState = {
  token: '',
  profile: { uuid: '', type: undefined },
}

// lazy load state
export interface State extends FrontState {
  authentication: AuthenticationState
}

const AuthReducer = createReducer(
  initialState,
  on(AuthActions.setAuthentication, (state, auth) => ({
    ...auth.authentication,
  })),
  on(AuthActions.logout, () => initialState),
  on(AuthActions.updateAuthProfile, (state, action) => ({
    ...state,
    profile: action.update.changes as ProfileEntity,
  })),
  on(AuthActions.verifySuccess, AuthActions.clearVerifyError, (state) => ({
    ...state,
    errors: { ...state.errors, verify: '' },
  })),
  on(AuthActions.verifyFailure, (state, action) => ({
    ...state,
    errors: {
      ...state.errors,
      verify: action.error.error.verification_code ? action.error.error.verification_code[0] : '',
    },
  })),
  on(AuthActions.updateToken, (state, action) => ({
    ...state,
    token: action.token,
    refresh_token: action.refresh_token,
  })),
)

export function reducer(state: AuthenticationEntity | undefined, action: Action): AuthenticationEntity {
  return AuthReducer(state, action)
}
